export { default as MagicCableCaptchaGridImageOne } from './1.webp';
export { default as MagicCableCaptchaGridImageTwo } from './2.webp';
export { default as MagicCableCaptchaGridImageThree } from './3.webp';
export { default as MagicCableCaptchaGridImageFour } from './4.webp';
export { default as MagicCableCaptchaGridImageFive } from './5.webp';
export { default as MagicCableCaptchaGridImageSix } from './6.webp';
export { default as MagicCableCaptchaGridImageSeven } from './7.webp';
export { default as MagicCableCaptchaGridImageEight } from './8.webp';
export { default as MagicCableCaptchaGridImageNine } from './9.webp';
